import React, { useState, useEffect, useCallback } from 'react';
import { aplicarFavicon, aplicarTitulo, aplicarFonte, hexParaRgb, FONTES_DISPONIVEIS } from '../../utils/siteBranding';

const DEFAULT_CONFIG = {
  cabecalho: {
    titulo: 'Minha Agenda',
    icone: '📅',
    subtitulo: 'Sistema de Agendamento Online',
    logo_url: ''
  },
  tipografia: {
    fonte: 'Inter'
  },
  cores: {
    primaria: '#0f5a30',
    primaria_escura: '#106311',
    fundo_app: '#f8fafc',
    header_fundo: '#ffffff',
    admin_header_inicio: '#348d52',
    admin_header_fim: '#0d5724'
  },
  login: {
    background_inicio: '#f0fdf4',
    background_fim: '#dcfce7',
    titulo: 'Acessar minha conta',
    descricao: 'Plataforma online de agendamento. Consulte os horários disponíveis, reserve sua vaga, gerencie e cancele agendamentos — tudo pelo celular ou computador.'
  },
  contato: {
    email_suporte: ''
  },
  favicon: {
    emoji: '🤸‍♀',
    url: ''
  },
  calendario: {
    modo: 'link'
  },
  layout: {
    cabecalho_fixo: true,
    mostrar_footer: true,
    desktop_max_width: '1400px'
  },
  mobile: {
    mostrar_nome_no_menu: true
  }
};

const PALETAS = [
  // ── Claras (8) ──────────────────────────────────────────────────────────────
  { nome: 'Verde Suave',    emoji: '🌿', cores: { primaria: '#4ade80', primaria_escura: '#16a34a', admin_header_inicio: '#86efac', admin_header_fim: '#16a34a' } },
  { nome: 'Azul Suave',     emoji: '💙', cores: { primaria: '#38bdf8', primaria_escura: '#0284c7', admin_header_inicio: '#7dd3fc', admin_header_fim: '#0284c7' } },
  { nome: 'Lilás Suave',    emoji: '💜', cores: { primaria: '#c084fc', primaria_escura: '#9333ea', admin_header_inicio: '#d8b4fe', admin_header_fim: '#9333ea' } },
  { nome: 'Rosa Suave',     emoji: '🌸', cores: { primaria: '#f472b6', primaria_escura: '#db2777', admin_header_inicio: '#f9a8d4', admin_header_fim: '#db2777' } },
  { nome: 'Pêssego Suave',  emoji: '🍑', cores: { primaria: '#fb923c', primaria_escura: '#ea580c', admin_header_inicio: '#fdba74', admin_header_fim: '#ea580c' } },
  { nome: 'Coral Suave',    emoji: '🪸', cores: { primaria: '#f87171', primaria_escura: '#dc2626', admin_header_inicio: '#fca5a5', admin_header_fim: '#dc2626' } },
  { nome: 'Turquesa Suave', emoji: '🩵', cores: { primaria: '#2dd4bf', primaria_escura: '#0d9488', admin_header_inicio: '#5eead4', admin_header_fim: '#0d9488' } },
  { nome: 'Dourado Suave',  emoji: '🌼', cores: { primaria: '#fbbf24', primaria_escura: '#d97706', admin_header_inicio: '#fcd34d', admin_header_fim: '#d97706' } },
  // ── Escuras (8) ─────────────────────────────────────────────────────────────
  { nome: 'Verde Floresta', emoji: '🌲', cores: { primaria: '#0f5a30', primaria_escura: '#106311', admin_header_inicio: '#348d52', admin_header_fim: '#0d5724' } },
  { nome: 'Azul Meia-Noite',emoji: '🌌', cores: { primaria: '#1e3a8a', primaria_escura: '#172554', admin_header_inicio: '#1e40af', admin_header_fim: '#172554' } },
  { nome: 'Roxo Profundo',  emoji: '🔮', cores: { primaria: '#581c87', primaria_escura: '#3b0764', admin_header_inicio: '#6b21a8', admin_header_fim: '#3b0764' } },
  { nome: 'Bordô Clássico', emoji: '🍷', cores: { primaria: '#881337', primaria_escura: '#4c0519', admin_header_inicio: '#9f1239', admin_header_fim: '#4c0519' } },
  { nome: 'Terracota Escuro',emoji: '🧱', cores: { primaria: '#7c2d12', primaria_escura: '#431407', admin_header_inicio: '#9a3412', admin_header_fim: '#431407' } },
  { nome: 'Vermelho Sangue',emoji: '🩸', cores: { primaria: '#7f1d1d', primaria_escura: '#450a0a', admin_header_inicio: '#991b1b', admin_header_fim: '#450a0a' } },
  { nome: 'Petróleo Escuro',emoji: '🌊', cores: { primaria: '#134e4a', primaria_escura: '#042f2e', admin_header_inicio: '#115e59', admin_header_fim: '#042f2e' } },
  { nome: 'Grafite Preto',  emoji: '⚫', cores: { primaria: '#27272a', primaria_escura: '#09090b', admin_header_inicio: '#52525b', admin_header_fim: '#09090b' } },
];

const ICONES_OPCOES = ['🤸‍♀', '🧘', '💪', '🏃‍♀', '⚡', '🌟', '✨', '🎯', '🏋️', '🤸', '🌸', '🦋', '💎', '🌺', '🍃'];
const FAVICON_OPCOES = ['🤸‍♀', '🧘', '💪', '⚡', '🌟', '✨', '🎯', '🌸', '🦋', '💎', '🌺', '🍃', '🏋️', '🤸'];
const MAX_WIDTHS = ['1200px', '1400px', '1600px', '100%'];
const LOGIN_BACKGROUNDS = [
  { nome: 'Verde Claro', inicio: '#f0fdf4', fim: '#dcfce7' },
  { nome: 'Azul Claro',  inicio: '#eff6ff', fim: '#dbeafe' },
  { nome: 'Roxo Claro',  inicio: '#faf5ff', fim: '#ede9fe' },
  { nome: 'Rosa Claro',  inicio: '#fff1f2', fim: '#ffe4e6' },
  { nome: 'Bege Quente', inicio: '#fffbeb', fim: '#fef3c7' },
  { nome: 'Vermelho Claro',   inicio: '#fef2f2', fim: '#fee2e2' },
  { nome: 'Turquesa Claro',   inicio: '#f0fdfa', fim: '#ccfbf1' },
  { nome: 'Amarelo Claro',    inicio: '#fefce8', fim: '#fef9c3' },
  { nome: 'Céu Claro',        inicio: '#f0f9ff', fim: '#e0f2fe' },
  { nome: 'Esmeralda Claro',  inicio: '#ecfdf5', fim: '#d1fae5' },
  { nome: 'Índigo Claro',     inicio: '#eef2ff', fim: '#e0e7ff' },
  { nome: 'Bordô Claro',      inicio: '#ffe4e6', fim: '#fecdd3' },
  { nome: 'Terracota Claro',  inicio: '#fff7ed', fim: '#ffedd5' },
  { nome: 'Cinza Claro',      inicio: '#f8fafc', fim: '#f1f5f9' },
  { nome: 'Branco Puro', inicio: '#ffffff', fim: '#f8fafc' }
];

function deepMerge(base, override) {
  const result = { ...base };
  for (const key in override) {
    if (override[key] && typeof override[key] === 'object' && !Array.isArray(override[key])) {
      result[key] = deepMerge(base[key] || {}, override[key]);
    } else if (override[key] !== undefined) {
      result[key] = override[key];
    }
  }
  return result;
}

function aplicarCSSVars(cores) {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', cores.primaria);
  root.style.setProperty('--color-primary-dark', cores.primaria_escura);
  const rgb = hexParaRgb(cores.primaria);
  if (rgb) root.style.setProperty('--color-primary-rgb', rgb);
  root.style.setProperty('--color-fundo-app', cores.fundo_app);
  root.style.setProperty('--color-header-bg', cores.header_fundo);
  root.style.setProperty('--admin-header-inicio', cores.admin_header_inicio);
  root.style.setProperty('--admin-header-fim', cores.admin_header_fim);
}

const S_btnGhost = {
  padding: '8px 14px', borderRadius: '9px', border: '1.5px solid #e2e8f0', background: 'white',
  color: '#334155', fontWeight: 600, fontSize: '0.8rem',
};

const MAX_IMAGEM_BYTES = 300 * 1024; // 300KB — imagem vira base64 salvo direto no JSON de configuração

function lerImagemComoBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) return resolve('');
    if (file.size > MAX_IMAGEM_BYTES) {
      reject(new Error(`Imagem muito grande (máx. ${Math.round(MAX_IMAGEM_BYTES / 1024)}KB). Use um PNG/SVG mais leve.`));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Erro ao ler o arquivo'));
    reader.readAsDataURL(file);
  });
}

// ── Componentes reutilizáveis ──────────────────────────────────────────────

const ColorField = ({ label, value, onChange }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <label style={{ fontSize: '0.8rem', fontWeight: '600', color: '#475569' }}>{label}</label>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#f8fafc', border: '1.5px solid #e2e8f0', borderRadius: '10px', padding: '6px 10px' }}>
      <div style={{ position: 'relative', width: '32px', height: '32px', borderRadius: '8px', overflow: 'hidden', flexShrink: 0, border: '2px solid #e2e8f0' }}>
        <input type="color" value={value} onChange={e => onChange(e.target.value)}
          style={{ position: 'absolute', top: '-4px', left: '-4px', width: '40px', height: '40px', border: 'none', cursor: 'pointer', padding: 0 }} />
      </div>
      <input type="text" value={value} onChange={e => onChange(e.target.value)}
        style={{ flex: 1, border: 'none', background: 'transparent', fontSize: '0.82rem', fontFamily: 'monospace', color: '#334155', outline: 'none' }}
        maxLength={7} />
    </div>
  </div>
);

const Toggle = ({ label, description, value, onChange }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #f1f5f9' }}>
    <div>
      <div style={{ fontWeight: '600', fontSize: '0.875rem', color: '#1e293b' }}>{label}</div>
      {description && <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '2px' }}>{description}</div>}
    </div>
    <button onClick={() => onChange(!value)} style={{
      width: '46px', height: '26px', borderRadius: '13px', border: 'none', cursor: 'pointer',
      background: value ? 'var(--color-primary, #0f5a30)' : '#cbd5e1',
      position: 'relative', transition: 'all 0.2s ease', flexShrink: 0
    }}>
      <span style={{
        position: 'absolute', top: '3px', width: '20px', height: '20px', borderRadius: '50%',
        background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        left: value ? '23px' : '3px', transition: 'left 0.2s ease'
      }} />
    </button>
  </div>
);

const SectionTitle = ({ children }) => (
  <h3 style={{ margin: '0 0 20px', fontSize: '0.85rem', color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', borderBottom: '1px solid #f1f5f9', paddingBottom: '10px' }}>
    {children}
  </h3>
);

const InfoBox = ({ color = 'blue', children }) => {
  const colors = {
    blue:   { bg: '#eff6ff', border: '#bfdbfe', text: '#1e40af' },
    green:  { bg: '#f0fdf4', border: '#bbf7d0', text: '#166534' },
    yellow: { bg: '#fffbeb', border: '#fde68a', text: '#92400e' },
    red:    { bg: '#fef2f2', border: '#fecaca', text: '#991b1b' }
  };
  const c = colors[color];
  return (
    <div style={{ background: c.bg, borderRadius: '12px', padding: '14px 16px', border: `1px solid ${c.border}`, fontSize: '0.82rem', color: c.text }}>
      {children}
    </div>
  );
};

// ── Componente principal ───────────────────────────────────────────────────

export const GerenciadorPersonalizacao = ({ createApi, isMobile }) => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [secaoAtiva, setSecaoAtiva] = useState('identidade');
  const [salvando, setSalvando] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [toast, setToast] = useState(null);
  const [alterado, setAlterado] = useState(false);

  useEffect(() => {
    const api = createApi();
    api.get('/site/configuracoes').then(res => {
      if (res.data.configuracoes && Object.keys(res.data.configuracoes).length > 0) {
        const merged = deepMerge(DEFAULT_CONFIG, res.data.configuracoes);
        setConfig(merged);
        aplicarCSSVars(merged.cores);
        aplicarFavicon(merged.favicon?.emoji || merged.cabecalho.icone, merged.favicon?.url);
        aplicarTitulo(merged.cabecalho?.titulo);
        aplicarFonte(merged.tipografia?.fonte);
        window.dispatchEvent(new CustomEvent('siteConfigUpdate', { detail: merged }));
      }
    }).catch(() => {}).finally(() => setCarregando(false));
  }, [createApi]);

  useEffect(() => {
    if (toast) { const t = setTimeout(() => setToast(null), 3500); return () => clearTimeout(t); }
  }, [toast]);

  const atualizar = useCallback((secao, campo, valor) => {
    setConfig(c => {
      const novoConfig = { ...c, [secao]: { ...c[secao], [campo]: valor } };
      if (secao === 'cores') { aplicarCSSVars(novoConfig.cores); window.dispatchEvent(new CustomEvent('siteConfigUpdate', { detail: novoConfig })); }
      if (secao === 'cabecalho') { if (campo === 'titulo') aplicarTitulo(valor); window.dispatchEvent(new CustomEvent('siteConfigUpdate', { detail: novoConfig })); }
      if (secao === 'favicon') aplicarFavicon(novoConfig.favicon.emoji, novoConfig.favicon.url);
      if (secao === 'tipografia') aplicarFonte(novoConfig.tipografia.fonte);
      return novoConfig;
    });
    setAlterado(true);
  }, []);

  const aplicarPaleta = (paleta) => {
    setConfig(c => {
      const novasCores = { ...c.cores, ...paleta.cores };
      const novoConfig = { ...c, cores: novasCores };
      aplicarCSSVars(novasCores);
      window.dispatchEvent(new CustomEvent('siteConfigUpdate', { detail: novoConfig }));
      return novoConfig;
    });
    setAlterado(true);
  };

  const salvar = async () => {
    setSalvando(true);
    try {
      const api = createApi();
      await api.put('/admin/site/configuracoes', { configuracoes: config });
      setToast({ type: 'success', message: '✅ Configurações salvas com sucesso!' });
      setAlterado(false);
      window.dispatchEvent(new CustomEvent('siteConfigUpdate', { detail: config }));
    } catch {
      setToast({ type: 'error', message: '❌ Erro ao salvar configurações.' });
    } finally {
      setSalvando(false);
    }
  };

  const restaurarPadroes = () => {
    setConfig(DEFAULT_CONFIG);
    aplicarCSSVars(DEFAULT_CONFIG.cores);
    aplicarFavicon(DEFAULT_CONFIG.favicon.emoji, DEFAULT_CONFIG.favicon.url);
    aplicarTitulo(DEFAULT_CONFIG.cabecalho.titulo);
    aplicarFonte(DEFAULT_CONFIG.tipografia.fonte);
    window.dispatchEvent(new CustomEvent('siteConfigUpdate', { detail: DEFAULT_CONFIG }));
    setAlterado(true);
  };

  const secoes = [
    { id: 'identidade', label: 'Identidade',  icon: '🏷️' },
    { id: 'cores',      label: 'Cores',        icon: '🎨' },
    { id: 'login',      label: 'Tela de Login',icon: '🔐' },
    { id: 'favicon',    label: 'Favicon',      icon: '🌐' },
    { id: 'calendario', label: 'Calendário',   icon: '📅' },
    { id: 'desktop',    label: 'Desktop',      icon: '🖥️' },
    { id: 'mobile',     label: 'Mobile',       icon: '📱' }
  ];

  if (carregando) return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
      <div style={{ width: '32px', height: '32px', border: '3px solid #e2e8f0', borderTopColor: 'var(--color-primary,#0f5a30)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
    </div>
  );

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", color: '#1e293b' }}>

      {/* Toast */}
      {toast && (
        <div style={{
          position: 'fixed', top: '20px', right: '20px', zIndex: 9999,
          background: toast.type === 'success' ? '#f0fdf4' : '#fef2f2',
          border: `1px solid ${toast.type === 'success' ? '#bbf7d0' : '#fecaca'}`,
          color: toast.type === 'success' ? '#166534' : '#991b1b',
          padding: '12px 20px', borderRadius: '12px', fontWeight: 600,
          boxShadow: '0 8px 24px rgba(0,0,0,0.1)', fontSize: '0.875rem', animation: 'fadeIn 0.3s ease'
        }}>{toast.message}</div>
      )}

      {/* Header */}
      <div style={{ padding: isMobile ? '16px' : '20px 28px', borderBottom: '1px solid #f1f5f9', background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '1.05rem' : '1.2rem', fontWeight: 700 }}>🎨 Personalização do Portal</h2>
          <p style={{ margin: '3px 0 0', fontSize: '0.8rem', color: '#64748b' }}>Cores, identidade visual, tela de login, favicon, calendário e layout</p>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button onClick={restaurarPadroes} style={{ padding: '8px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', background: 'white', color: '#64748b', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer' }}>
            ↺ Padrões
          </button>
          <button onClick={salvar} disabled={salvando || !alterado} style={{
            padding: '8px 18px', borderRadius: '10px', border: 'none',
            background: alterado ? 'var(--color-primary,#0f5a30)' : '#e2e8f0',
            color: alterado ? 'white' : '#94a3b8', fontSize: '0.8rem', fontWeight: 700,
            cursor: alterado ? 'pointer' : 'not-allowed', transition: 'all 0.2s ease',
            boxShadow: alterado ? '0 4px 12px rgba(15,90,48,0.25)' : 'none'
          }}>
            {salvando ? 'Salvando...' : '💾 Salvar'}
          </button>
        </div>
      </div>

      {/* Layout */}
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '520px' }}>

        {/* Sidebar */}
        <div style={{
          width: isMobile ? '100%' : '190px', flexShrink: 0,
          borderRight: isMobile ? 'none' : '1px solid #f1f5f9',
          borderBottom: isMobile ? '1px solid #f1f5f9' : 'none',
          background: '#fafbfc',
          display: 'flex', flexDirection: isMobile ? 'row' : 'column',
          overflowX: isMobile ? 'auto' : 'visible',
          padding: isMobile ? '8px' : '12px 8px'
        }}>
          {secoes.map(s => (
            <button key={s.id} onClick={() => setSecaoAtiva(s.id)} style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: isMobile ? '9px 14px' : '10px 12px',
              borderRadius: '10px', border: 'none', cursor: 'pointer',
              background: secaoAtiva === s.id ? 'var(--color-primary,#0f5a30)' : 'transparent',
              color: secaoAtiva === s.id ? 'white' : '#475569',
              fontSize: '0.82rem', fontWeight: secaoAtiva === s.id ? 700 : 500,
              whiteSpace: 'nowrap', transition: 'all 0.15s ease',
              marginBottom: isMobile ? 0 : '2px', marginRight: isMobile ? '4px' : 0,
              flexShrink: 0, textAlign: 'left'
            }}>
              <span>{s.icon}</span>{s.label}
            </button>
          ))}
        </div>

        {/* Conteúdo */}
        <div style={{ flex: 1, padding: isMobile ? '16px' : '24px 28px', overflowY: 'auto' }}>

          {/* ═══ IDENTIDADE VISUAL ═══ */}
          {secaoAtiva === 'identidade' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '520px' }}>
              <SectionTitle>Identidade Visual</SectionTitle>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Logo (PNG ou SVG)</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '52px', height: '52px', borderRadius: '10px', border: '1.5px dashed #cbd5e1',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white', overflow: 'hidden', flexShrink: 0
                  }}>
                    {config.cabecalho.logo_url
                      ? <img src={config.cabecalho.logo_url} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                      : <span style={{ fontSize: '1.4rem' }}>{config.cabecalho.icone}</span>}
                  </div>
                  <label style={{ ...S_btnGhost, cursor: 'pointer' }}>
                    Enviar imagem
                    <input type="file" accept="image/png,image/svg+xml,image/webp" style={{ display: 'none' }}
                      onChange={async e => {
                        try {
                          const base64 = await lerImagemComoBase64(e.target.files[0]);
                          if (base64) atualizar('cabecalho', 'logo_url', base64);
                        } catch (err) {
                          setToast({ type: 'error', message: `❌ ${err.message}` });
                        } finally {
                          e.target.value = '';
                        }
                      }} />
                  </label>
                  {config.cabecalho.logo_url && (
                    <button type="button" onClick={() => atualizar('cabecalho', 'logo_url', '')} style={S_btnGhost}>Remover</button>
                  )}
                </div>
                <p style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '6px' }}>
                  Se enviada, a logo substitui o ícone abaixo no cabeçalho e na tela de login. PNG ou SVG, até 300KB.
                </p>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Ícone do Logotipo (usado se não houver logo)</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {ICONES_OPCOES.map(ic => (
                    <button key={ic} onClick={() => atualizar('cabecalho', 'icone', ic)} style={{
                      width: '44px', height: '44px', borderRadius: '10px', fontSize: '1.4rem',
                      border: config.cabecalho.icone === ic ? '2.5px solid var(--color-primary,#0f5a30)' : '2px solid #e2e8f0',
                      background: config.cabecalho.icone === ic ? '#f0fdf4' : 'white',
                      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s'
                    }}>{ic}</button>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Título do Site</label>
                <input type="text" value={config.cabecalho.titulo} onChange={e => atualizar('cabecalho', 'titulo', e.target.value)}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }}
                  placeholder="Nome do seu negócio" />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Subtítulo / Tagline</label>
                <input type="text" value={config.cabecalho.subtitulo} onChange={e => atualizar('cabecalho', 'subtitulo', e.target.value)}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }}
                  placeholder="Slogan ou descrição curta" />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>E-mail de Suporte (rodapé "Contato")</label>
                <input type="email" value={config.contato?.email_suporte || ''} onChange={e => atualizar('contato', 'email_suporte', e.target.value)}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }}
                  placeholder="contato@seunegocio.com.br" />
                <p style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '6px' }}>Se vazio, o link "Contato" fica oculto.</p>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Fonte do Site</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {FONTES_DISPONIVEIS.map(f => (
                    <button key={f.id} onClick={() => atualizar('tipografia', 'fonte', f.id)} style={{
                      padding: '10px 16px', borderRadius: '10px', fontSize: '0.9rem', fontFamily: f.pilha,
                      border: config.tipografia?.fonte === f.id ? '2.5px solid var(--color-primary,#0f5a30)' : '2px solid #e2e8f0',
                      background: config.tipografia?.fonte === f.id ? '#f0fdf4' : 'white',
                      cursor: 'pointer', transition: 'all 0.15s'
                    }}>{f.label}</button>
                  ))}
                </div>
                <p style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '6px' }}>Aplicada em todo o sistema — título, textos e botões.</p>
              </div>

              {/* Preview cabeçalho */}
              <div style={{ background: '#f8fafc', borderRadius: '14px', padding: '16px', border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: '0.7rem', color: '#94a3b8', marginBottom: '10px', fontWeight: 700, letterSpacing: '0.05em' }}>PRÉVIA DO CABEÇALHO</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', background: config.cores.header_fundo, padding: '12px 16px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                  {config.cabecalho.logo_url
                    ? <img src={config.cabecalho.logo_url} alt="Logo" style={{ height: '28px', maxWidth: '120px', objectFit: 'contain' }} />
                    : <span style={{ fontSize: '1.6rem' }}>{config.cabecalho.icone}</span>}
                  <div>
                    <div style={{ fontWeight: 700, fontSize: '1rem', color: config.cores.primaria }}>{config.cabecalho.titulo}</div>
                    <div style={{ fontSize: '0.7rem', color: '#94a3b8', marginTop: '2px' }}>{config.cabecalho.subtitulo}</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ═══ CORES ═══ */}
          {secaoAtiva === 'cores' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', maxWidth: '560px' }}>
              <SectionTitle>Paleta de Cores</SectionTitle>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Temas Predefinidos</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {PALETAS.map(p => (
                    <button key={p.nome} onClick={() => aplicarPaleta(p)} title={p.nome} style={{
                      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px',
                      padding: '10px 12px', borderRadius: '12px', border: '2px solid',
                      borderColor: config.cores.primaria === p.cores.primaria ? p.cores.primaria : '#e2e8f0',
                      background: config.cores.primaria === p.cores.primaria ? '#f8fafc' : 'white',
                      cursor: 'pointer', transition: 'all 0.15s', minWidth: '68px'
                    }}>
                      <div style={{ display: 'flex', gap: '3px' }}>
                        {[p.cores.primaria, p.cores.primaria_escura, p.cores.admin_header_inicio].map((c, i) => (
                          <span key={i} style={{ width: '14px', height: '14px', borderRadius: '50%', background: c, display: 'block' }} />
                        ))}
                      </div>
                      <span style={{ fontSize: '0.7rem', fontWeight: 600, color: '#475569', whiteSpace: 'nowrap' }}>{p.emoji} {p.nome}</span>
                    </button>
                  ))}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '14px' }}>
                <ColorField label="Cor Principal"          value={config.cores.primaria}             onChange={v => atualizar('cores', 'primaria', v)} />
                <ColorField label="Cor Principal Escura"   value={config.cores.primaria_escura}       onChange={v => atualizar('cores', 'primaria_escura', v)} />
                <ColorField label="Fundo do App"           value={config.cores.fundo_app}             onChange={v => atualizar('cores', 'fundo_app', v)} />
                <ColorField label="Fundo do Cabeçalho"     value={config.cores.header_fundo}          onChange={v => atualizar('cores', 'header_fundo', v)} />
                <ColorField label="Header Admin (início)"  value={config.cores.admin_header_inicio}   onChange={v => atualizar('cores', 'admin_header_inicio', v)} />
                <ColorField label="Header Admin (fim)"     value={config.cores.admin_header_fim}      onChange={v => atualizar('cores', 'admin_header_fim', v)} />
              </div>

              <div style={{ background: '#f8fafc', borderRadius: '14px', padding: '16px', border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: '0.7rem', color: '#94a3b8', marginBottom: '12px', fontWeight: 700, letterSpacing: '0.05em' }}>PRÉVIA DOS ELEMENTOS</div>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <button style={{ background: config.cores.primaria, color: 'white', border: 'none', borderRadius: '10px', padding: '9px 18px', fontWeight: 600, fontSize: '0.85rem', cursor: 'default' }}>Botão Principal</button>
                  <button style={{ background: 'white', color: config.cores.primaria, border: `2px solid ${config.cores.primaria}`, borderRadius: '10px', padding: '8px 18px', fontWeight: 600, fontSize: '0.85rem', cursor: 'default' }}>Botão Outline</button>
                  <div style={{ background: `linear-gradient(135deg,${config.cores.admin_header_inicio},${config.cores.admin_header_fim})`, padding: '8px 16px', borderRadius: '10px', color: 'white', fontWeight: 600, fontSize: '0.82rem' }}>Header Admin</div>
                </div>
              </div>
            </div>
          )}

          {/* ═══ TELA DE LOGIN ═══ */}
          {secaoAtiva === 'login' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '560px' }}>
              <SectionTitle>Tela de Login</SectionTitle>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Fundo da Página de Login</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {LOGIN_BACKGROUNDS.map(bg => (
                    <button key={bg.nome} onClick={() => {
                      atualizar('login', 'background_inicio', bg.inicio);
                      setConfig(c => ({ ...c, login: { ...c.login, background_inicio: bg.inicio, background_fim: bg.fim } }));
                      setAlterado(true);
                    }} title={bg.nome} style={{
                      width: '52px', height: '40px', borderRadius: '10px', cursor: 'pointer',
                      background: `linear-gradient(135deg,${bg.inicio},${bg.fim})`,
                      border: config.login.background_inicio === bg.inicio ? '3px solid var(--color-primary,#0f5a30)' : '2px solid #e2e8f0',
                      transition: 'all 0.15s'
                    }} title={bg.nome} />
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                  <ColorField label="Cor início" value={config.login.background_inicio} onChange={v => atualizar('login', 'background_inicio', v)} />
                  <ColorField label="Cor fim"    value={config.login.background_fim}    onChange={v => atualizar('login', 'background_fim', v)} />
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Título do Card de Login</label>
                <input type="text" value={config.login.titulo} onChange={e => atualizar('login', 'titulo', e.target.value)}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', fontSize: '0.9rem', outline: 'none', boxSizing: 'border-box' }}
                  placeholder="Acessar minha conta" />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Descrição / Boas-vindas</label>
                <textarea value={config.login.descricao} onChange={e => atualizar('login', 'descricao', e.target.value)} rows={3}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }}
                  placeholder="Texto de boas-vindas exibido na tela de login" />
              </div>

              {/* Preview login */}
              <div style={{ background: `linear-gradient(160deg,${config.login.background_inicio},${config.login.background_fim})`, borderRadius: '14px', padding: '20px', border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: '0.7rem', color: '#64748b', marginBottom: '12px', fontWeight: 700, letterSpacing: '0.05em' }}>PRÉVIA DA TELA DE LOGIN</div>
                <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                  <div style={{ fontSize: '2rem' }}>{config.cabecalho.icone}</div>
                  <div style={{ fontWeight: 800, fontSize: '1.2rem', color: config.cores.primaria, margin: '4px 0 2px' }}>{config.cabecalho.titulo}</div>
                  <div style={{ fontSize: '0.75rem', color: '#374151', lineHeight: 1.5 }}>{config.login.descricao?.slice(0, 80)}...</div>
                </div>
                <div style={{ background: 'white', borderRadius: '12px', padding: '12px 16px', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', textAlign: 'center' }}>
                  <div style={{ background: `linear-gradient(135deg,${config.cores.admin_header_inicio},${config.cores.admin_header_fim})`, borderRadius: '8px 8px 0 0', margin: '-12px -16px 12px', padding: '10px', color: 'white', fontWeight: 600, fontSize: '0.85rem' }}>{config.login.titulo}</div>
                  <div style={{ background: '#f1f5f9', borderRadius: '8px', padding: '8px 12px', fontSize: '0.75rem', color: '#475569' }}>🔐 Entrar com Google</div>
                </div>
              </div>
            </div>
          )}

          {/* ═══ FAVICON ═══ */}
          {secaoAtiva === 'favicon' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '480px' }}>
              <SectionTitle>Favicon (Ícone da Aba)</SectionTitle>

              <InfoBox color="blue">
                <strong>💡 Dica:</strong> O favicon aparece na aba do navegador e ao salvar o site na tela inicial do celular. Use um emoji simples e reconhecível, ou cole a URL de uma imagem .ico ou .png (32×32px).
              </InfoBox>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Escolher Emoji como Favicon</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {FAVICON_OPCOES.map(em => (
                    <button key={em} onClick={() => { atualizar('favicon', 'emoji', em); atualizar('favicon', 'url', ''); aplicarFavicon(em, ''); }} style={{
                      width: '48px', height: '48px', borderRadius: '10px', fontSize: '1.5rem',
                      border: config.favicon.emoji === em && !config.favicon.url ? '2.5px solid var(--color-primary,#0f5a30)' : '2px solid #e2e8f0',
                      background: config.favicon.emoji === em && !config.favicon.url ? '#f0fdf4' : 'white',
                      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s'
                    }}>{em}</button>
                  ))}
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Ou Envie um Arquivo (.ico, .png, .svg)</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <label style={{ ...S_btnGhost, cursor: 'pointer' }}>
                    Escolher arquivo
                    <input type="file" accept="image/x-icon,image/png,image/svg+xml,.ico" style={{ display: 'none' }}
                      onChange={async e => {
                        try {
                          const base64 = await lerImagemComoBase64(e.target.files[0]);
                          if (base64) { atualizar('favicon', 'url', base64); aplicarFavicon(config.favicon.emoji, base64); }
                        } catch (err) {
                          setToast({ type: 'error', message: `❌ ${err.message}` });
                        } finally {
                          e.target.value = '';
                        }
                      }} />
                  </label>
                  {config.favicon.url && (
                    <button type="button" onClick={() => { atualizar('favicon', 'url', ''); aplicarFavicon(config.favicon.emoji, ''); }} style={S_btnGhost}>Remover</button>
                  )}
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '6px' }}>Ou Cole a URL de uma Imagem</label>
                <input type="url" value={config.favicon.url?.startsWith('data:') ? '' : config.favicon.url} onChange={e => { atualizar('favicon', 'url', e.target.value); if (e.target.value) aplicarFavicon(config.favicon.emoji, e.target.value); }}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #e2e8f0', fontSize: '0.85rem', outline: 'none', boxSizing: 'border-box' }}
                  placeholder="https://seusite.com/favicon.ico" />
                <p style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '6px' }}>Arquivo enviado ou URL — o que for preenchido por último sobrepõe o emoji acima.</p>
              </div>

              {/* Preview favicon */}
              <div style={{ background: '#1e293b', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ background: '#334155', borderRadius: '8px', padding: '6px 14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '1.1rem' }}>{config.favicon.url ? '🖼️' : config.favicon.emoji}</span>
                  <span style={{ color: '#e2e8f0', fontSize: '0.8rem', fontWeight: 500 }}>{config.cabecalho.titulo}</span>
                  <span style={{ color: '#64748b', fontSize: '0.8rem' }}>×</span>
                </div>
                <span style={{ color: '#94a3b8', fontSize: '0.75rem' }}>← Prévia da aba do navegador</span>
              </div>
            </div>
          )}

          {/* ═══ CALENDÁRIO ═══ */}
          {secaoAtiva === 'calendario' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '560px' }}>
              <SectionTitle>Integração Google Agenda</SectionTitle>

              <InfoBox color="green">
                <strong>✅ Calendário da academia:</strong> Sincronizado automaticamente pelo servidor via Service Account — funciona sempre, independente desta configuração.
              </InfoBox>

              <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                {/* Opção Link */}
                <div
                  onClick={() => atualizar('calendario', 'modo', 'link')}
                  style={{
                    padding: '18px 20px', cursor: 'pointer', transition: 'background 0.15s',
                    background: config.calendario.modo === 'link' ? '#f0fdf4' : 'white',
                    borderLeft: config.calendario.modo === 'link' ? '4px solid var(--color-primary,#0f5a30)' : '4px solid transparent',
                    borderBottom: '1px solid #f1f5f9'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                    <div style={{
                      width: '20px', height: '20px', borderRadius: '50%', border: '2px solid',
                      borderColor: config.calendario.modo === 'link' ? 'var(--color-primary,#0f5a30)' : '#cbd5e1',
                      background: config.calendario.modo === 'link' ? 'var(--color-primary,#0f5a30)' : 'white',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px'
                    }}>
                      {config.calendario.modo === 'link' && <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'white', display: 'block' }} />}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.95rem', color: '#1e293b', marginBottom: '4px' }}>
                        📆 Link Google Agenda <span style={{ background: '#dcfce7', color: '#166534', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '20px', marginLeft: '6px' }}>Recomendado</span>
                      </div>
                      <div style={{ fontSize: '0.82rem', color: '#64748b', lineHeight: 1.6 }}>
                        Após agendar, o cliente vê um botão <strong>"📆 Adicionar ao Google Agenda"</strong> que abre o app do Google Agenda com o evento já preenchido — um toque e está salvo. <strong>Não requer permissões especiais do Google, sem aviso de "app não verificado".</strong>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Opção OAuth */}
                <div
                  onClick={() => atualizar('calendario', 'modo', 'oauth')}
                  style={{
                    padding: '18px 20px', cursor: 'pointer', transition: 'background 0.15s',
                    background: config.calendario.modo === 'oauth' ? '#eff6ff' : 'white',
                    borderLeft: config.calendario.modo === 'oauth' ? '4px solid #2563eb' : '4px solid transparent'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                    <div style={{
                      width: '20px', height: '20px', borderRadius: '50%', border: '2px solid',
                      borderColor: config.calendario.modo === 'oauth' ? '#2563eb' : '#cbd5e1',
                      background: config.calendario.modo === 'oauth' ? '#2563eb' : 'white',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px'
                    }}>
                      {config.calendario.modo === 'oauth' && <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'white', display: 'block' }} />}
                    </div>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.95rem', color: '#1e293b', marginBottom: '4px' }}>
                        🔐 OAuth Automático <span style={{ background: '#fef3c7', color: '#92400e', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '20px', marginLeft: '6px' }}>Requer verificação Google</span>
                      </div>
                      <div style={{ fontSize: '0.82rem', color: '#64748b', lineHeight: 1.6 }}>
                        O sistema solicita permissão ao cliente no primeiro login e adiciona o evento automaticamente no Google Agenda pessoal sem nenhuma interação adicional. <strong>Exige que o app passe pela verificação formal do Google</strong> (processo de 1 a 6 semanas) para eliminar o aviso de "app não verificado".
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {config.calendario.modo === 'oauth' && (
                <InfoBox color="yellow">
                  <strong>⚠️ Atenção:</strong> Com OAuth ativo e app não verificado pelo Google, os clientes verão um aviso de "informações confidenciais" ao fazer login. Para remover este aviso, acesse o <strong>Google Cloud Console → APIs &amp; Services → OAuth consent screen</strong> e submeta o app para verificação.
                </InfoBox>
              )}

              {config.calendario.modo === 'link' && (
                <InfoBox color="green">
                  <strong>✅ Configuração segura:</strong> Nenhum aviso do Google será exibido. Ao agendar, o cliente vê o botão "📆 Adicionar ao Google Agenda" que funciona em qualquer celular ou computador sem instalações ou permissões adicionais.
                </InfoBox>
              )}
            </div>
          )}

          {/* ═══ LAYOUT DESKTOP ═══ */}
          {secaoAtiva === 'desktop' && (
            <div style={{ maxWidth: '480px' }}>
              <SectionTitle>Layout — Desktop</SectionTitle>

              <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #e2e8f0', padding: '8px 16px', marginBottom: '16px' }}>
                <Toggle label="Cabeçalho fixo" description="Mantém o header visível ao rolar a página" value={config.layout.cabecalho_fixo} onChange={v => atualizar('layout', 'cabecalho_fixo', v)} />
                <Toggle label="Mostrar rodapé" description="Exibe o footer com links e créditos" value={config.layout.mostrar_footer} onChange={v => atualizar('layout', 'mostrar_footer', v)} />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '10px' }}>Largura Máxima do Conteúdo</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {MAX_WIDTHS.map(w => (
                    <button key={w} onClick={() => atualizar('layout', 'desktop_max_width', w)} style={{
                      padding: '8px 18px', borderRadius: '10px', fontSize: '0.85rem', fontWeight: 600,
                      border: '2px solid', cursor: 'pointer', transition: 'all 0.15s',
                      borderColor: config.layout.desktop_max_width === w ? 'var(--color-primary,#0f5a30)' : '#e2e8f0',
                      background: config.layout.desktop_max_width === w ? 'var(--color-primary,#0f5a30)' : 'white',
                      color: config.layout.desktop_max_width === w ? 'white' : '#475569'
                    }}>{w}</button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ═══ LAYOUT MOBILE ═══ */}
          {secaoAtiva === 'mobile' && (
            <div style={{ maxWidth: '480px' }}>
              <SectionTitle>Layout — Mobile</SectionTitle>

              <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #e2e8f0', padding: '8px 16px', marginBottom: '20px' }}>
                <Toggle label="Nome do usuário no menu" description="Exibe o nome completo no menu hamburguer" value={config.mobile.mostrar_nome_no_menu} onChange={v => atualizar('mobile', 'mostrar_nome_no_menu', v)} />
              </div>

              <InfoBox color="blue">
                <strong>💡 Dica:</strong> Alterações de cores e identidade visual se aplicam automaticamente ao mobile. Use as abas <strong>Identidade</strong> e <strong>Cores</strong> para personalizar elementos comuns.
              </InfoBox>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};
